import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["abbreviate", "abbreviateThreshold", "value"];
import { getLocale } from '../utils/internal/light/intlFormatters';
import { formatIntlCurrency } from '../utils/formatIntlCurrency';
// @ts-expect-error untyped
import LegacyFormattedCurrency from './FormattedCurrency';
import devLogger from 'react-utils/devLogger';
import { jsx as _jsx } from "react/jsx-runtime";
export function FormattedIntlCurrency(props) {
  try {
    const {
        abbreviate,
        abbreviateThreshold,
        value
      } = props,
      options = _objectWithoutPropertiesLoose(props, _excluded);
    const wrapperAttributes = {};
    const shouldAbbreviate = abbreviate && (typeof abbreviateThreshold !== 'number' || value >= abbreviateThreshold);
    if (shouldAbbreviate) {
      // Set the title attribute to the full, unabbreviated currency value
      wrapperAttributes.title = formatIntlCurrency(value, options);
    }
    const formattedCurrency = formatIntlCurrency(value, Object.assign({}, options, {
      abbreviate: shouldAbbreviate
    }));
    return /*#__PURE__*/_jsx("span", Object.assign({}, wrapperAttributes, {
      children: formattedCurrency
    }));
  } catch (e) {
    const message = `I18n: FormattedIntlCurrency Error - ${e}`;
    devLogger.warn({
      message,
      key: `I18n.FormattedIntlCurrency-runtimeError`
    });
    if (window.Raven) {
      window.Raven.captureException(new Error(message), {
        extra: {
          currentLocale: getLocale(props),
          props
        }
      });
    }
    return /*#__PURE__*/_jsx(LegacyFormattedCurrency, Object.assign({}, props));
  }
}
FormattedIntlCurrency.defaultProps = {
  stripInsignificantZeros: false
};